import React, { FC } from 'react';
import cn from 'classnames';

import css from './WaveSpeakAnimation.module.scss';

type Props = {
  className?: string;
  isSpeaking: boolean;
};

const WaveSpeakAnimation: FC<Props> = ({ className, isSpeaking }) => {
  return (
    <div className={cn(css.waves, className, isSpeaking && css.active)}>
      <div className={`${css.wave} ${css.one}`} />
      <div className={`${css.wave} ${css.two}`} />
      <div className={`${css.wave} ${css.three}`} />
    </div>
  );
};

export default WaveSpeakAnimation;
